import * as Scrivito from "scrivito";

const IconWidget = Scrivito.provideWidgetClass("IconWidget", {
  attributes: {
    icon: "string",
    size: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    sizeMobile: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    sizeTablet: [
      "enum",
      { values: ["100", "200", "300", "400", "500", "600", "700"] },
    ],
    alignment: ["enum", { values: ["left", "center", "right"] }],
    link: "link",
    iconColor: [
      "enum",
      {
        values: ["black", "white", "blue", "teal"],
      },
    ],
  },
});

export default IconWidget;
